import classNames from "classnames"
import { Select } from "web/components/Form/Controls"

export default function TileSizeSelectors({
  tileWidth,
  tileHeight,
  setTileHeight,
  setTileWidth,
  limitTileSizeOptions = { width: 2, height: 4 },
}) {
  const widthOptions = [
    { label: "(1) Half", value: 1 },
    { label: "(2) Full", value: 2 },
  ]

  const heightOptions = [
    { label: "(1) Quarter", value: 1 },
    { label: "(2) Half", value: 2 },
    { label: "(3) Three Quarters", value: 3 },
    { label: "(4) Full", value: 4 },
  ]

  const limitedWidthOptions = widthOptions.filter(
    (opts) => opts.value <= limitTileSizeOptions.width
  )
  const limitedHeightOptions = heightOptions.filter(
    (opts) => opts.value <= limitTileSizeOptions.height
  )

  const canShowWidthDropdown = !!limitedWidthOptions.length
  const canShowHeightDropdown = !!limitedHeightOptions.length

  const getDropdownContainerClasses = (isHalfWidth = false) =>
    classNames({
      "w-1/2": isHalfWidth,
      "w-full": !isHalfWidth,
    })

  return (
    <div className="flex justify-between gap-2">
      {canShowWidthDropdown && (
        <div className={getDropdownContainerClasses(canShowHeightDropdown)}>
          <Select
            id="tile-width"
            label="Tile Width"
            description="Set the tile width on the overview"
            kind="Number"
            value={tileWidth}
            isRequired={true}
            placeholder={limitedWidthOptions[tileWidth.value - 1].label}
            options={limitedWidthOptions}
            onChange={setTileWidth}
            includeNullSuggestion={false}
          />
        </div>
      )}
      {canShowHeightDropdown && (
        <div className={getDropdownContainerClasses(canShowWidthDropdown)}>
          <Select
            id="tile-height"
            label="Tile Height"
            description="Set the tile Height on the overview"
            kind="Number"
            value={tileHeight}
            isRequired={true}
            placeholder={limitedHeightOptions[tileHeight.value - 1].label}
            options={limitedHeightOptions}
            onChange={setTileHeight}
            includeNullSuggestion={false}
          />
        </div>
      )}
    </div>
  )
}
